// Capture & persist a partner referral code (?ref=XXX) for 60 days.
// Read it back at lead-submission time to attribute the lead.

const KEY = "cm_ref";
const MAX_AGE_DAYS = 60;

type Stored = { code: string; ts: number };

export function captureReferralFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get("ref");
    if (!raw) return null;
    const code = raw.trim().toUpperCase().slice(0, 20);
    if (code.length < 3) return null;
    const payload: Stored = { code, ts: Date.now() };
    localStorage.setItem(KEY, JSON.stringify(payload));
    return code;
  } catch {
    return null;
  }
}

export function getReferralCode(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Stored;
    const ageDays = (Date.now() - parsed.ts) / (1000 * 60 * 60 * 24);
    if (ageDays > MAX_AGE_DAYS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.code || null;
  } catch {
    return null;
  }
}

export function clearReferralCode() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
